import {MessageStatus} from 'api/types/properties'
import {NinchatStoreMessage} from 'api/types/store'

type HistoryCursorMessage = Pick<NinchatStoreMessage, '_message_status' | 'message_id'>

export const getHistoryCursorMessageId = (messages?: HistoryCursorMessage[]): string | undefined => {
    const oldestServerMessage = messages?.find((message) => message._message_status !== MessageStatus.PENDING && message._message_status !== MessageStatus.REJECTED)
    return oldestServerMessage?.message_id
}
